// @ts-nocheck
import request from '../utils/request';
export function fetchPromoCodes(filters) {
    const params = new URLSearchParams();
    if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, String(value));
            }
        });
    }
    const queryString = params.toString();
    const url = queryString
        ? `/api/v1/admin/promo-codes/?${queryString}`
        : '/api/v1/admin/promo-codes/';
    return request()
        .get(url)
        .send();
}
export function fetchPromoCode(id) {
    return request()
        .get(`/api/v1/admin/promo-codes/${id}/`)
        .send();
}
export function createPromoCode(data) {
    return request()
        .post('/api/v1/admin/promo-codes/')
        .send(data);
}
export function updatePromoCode(id, data) {
    return request()
        .patch(`/api/v1/admin/promo-codes/${id}/`)
        .send(data);
}
export function deletePromoCode(id) {
    return request()
        .delete(`/api/v1/admin/promo-codes/${id}/`)
        .send();
}
